import * as React from 'react';
import './ComponentHeader.css';

export interface ComponentHeaderProps {
    text: string
}

const ComponentHeader = (props: ComponentHeaderProps) => (
    <div className="component-header">
        <h4>{props.text}</h4>
    </div>
);

export default ComponentHeader;